<template>
  <span
    class="inline-flex items-center gap-1 underline text-primary dark:text-brand decoration-primary/25 dark:decoration-[#a49ce8]/25 underline-offset-2 hover:decoration-primary/75 hover:dark:decoration-[#a49ce8]/75 cursor-pointer"
    @mousedown.stop
  >
    {{ name }}
    <ExternalLink class="size-3 shrink-0 text-muted-foreground" />
  </span>
</template>

<script setup lang="ts">
import { ExternalLink } from '@lucide/vue'

type Props = {
  name: string
}

const { name } = defineProps<Props>()
</script>
